<template>
<div class="batch">
    <div class="btns">
        <i class="iconfont iconpiliangcaozuo batch-icon"></i>
        <span>批量操作</span>
    </div>
    <ul class="controls">
        <li @click="clearSubtitles">清空字幕</li>
        <li @click="clearDubbings">清空配音</li>
        <li @click="clearSoundTracks">清空配乐</li>
    </ul>
</div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    name: "Batch",
    data () {
        return {}
    },
    computed: {
    ...mapGetters({
      musicArr: 'addSoundtrack/getMusicArr',
    })
    },
    methods: {
       popup (msg, callbackFunc) {
           this.$modal.show("SubtitleMessageDialog", {
            view: "Common",
            msg: `确定要清空${msg}轴上的所有内容吗？（操作不可恢复）`,
            resultCallback: (value) => {
            if (value && value.type == "Ok") {
                callbackFunc();
            }
            },
        });
       },
       clearSubtitles () {
         this.popup('字幕', () => {
             this.$store.commit('subtitle/clearSubtitles');
             setTimeout(() => {
                this.$bus.emit('subtitle_keycode_del');
            }, 10);
            // this.$bus.emit("insert_subtitle_undo", {
            //     type: "clearSubtitles",
            //     data: {
            //     },
            // });
         });
       },
       clearDubbings () {
        this.popup('配音', () => {
             this.$store.commit('addSoundtrack/clearSound', 'dubbing');
            //  this.$bus.emit("insert_subtitle_undo", {
            //     type: "clearDubbings",
            //     data: {
            //     },
            //  });
        });
       },
       clearSoundTracks () {
           this.popup('配乐', () => {
             this.$store.commit('addSoundtrack/clearSound', 'music');
             this.$store.commit('addSoundtrack/setLoopSoundtrackStatus', false);
            //  this.$bus.emit("insert_subtitle_undo", {
            //     type: "clearSoundTracks",
            //     data: {
            //         musics: this.musicArr.slice(0)
            //     },
            //  });
        });
           
       }
    }
}
</script>
<style lang="scss" scoped>
.batch {
    position: absolute;
    right: 304px;
    bottom: 202px;
    z-index: 100;
    cursor: pointer;
    font-size: 14px;
    color: #474261;
    opacity: 1;
    line-height: 16px;
    padding-top: 30px;
    .batch-icon {
        font-size: 10px;
    }
    &:hover {
        opacity: 0.8;
        .controls {
            opacity: 1;
            display: block;
        }
    }
    .controls {
        position: absolute;
        width: 80px;
        text-align: center;
        bottom: 28px;
        left: 0;
        border: 1px solid #D8DEE9;
        opacity: 1;
        border-radius: 4px;
        overflow: hidden;
        display: none;
        li {
            font-size: 12px;
            padding: 7px 0;
            background-color: #fff;
            &:hover {
                background-color: #F5F7FA;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/subtitle/batch.vue